/* Use this component to extend specific search components */
import { Component, OnInit, Input } from '@angular/core';

import * as State from '@shared/state';
import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';
import { IMenuFlowPage } from '@shared/state';

@Component({
    template: '<div>This component requires extending</div>'
})
export class WizzardTypeComponent implements OnInit {
    @Input() public type: State.MODAL_TYPE;
    @Input() public locationNo: number;
    @Input() public menuFlowId: number;
    @Input() public quantityMobile: boolean = true; /* Consumer -> wizzard-quantity - visible on mobile */
    @Input() public quantityDesktop: boolean = false; /* Consumer -> wizzard-quantity - visible on desktop */
    @Input() public showDisclaimer: boolean = true;

    public menuFlowDetails$: Observable<State.IMenuFlows>;
    public menuFlowPages$: Observable<IMenuFlowPage[]>;
    public combinedMenuFlowPages$: Observable<IMenuFlowPage[]>;
    public showSpecialInstructions$: Observable<boolean>;
    public showQuantityWizard$: Observable<boolean>;
    public hasSpecialInstructions$: Observable<boolean>;
    public wizzardMenuFlow$: Observable<State.IWizzardMenuFlow>;
    public isEditing$: Observable<boolean>;

    constructor(
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        this.menuFlowDetails$ = this.controllers.menuFlows.menuFlowDetails$(this.menuFlowId, this.locationNo);
        this.menuFlowPages$ = this.controllers.menuFlows.menuFlowPages$(this.menuFlowId, this.locationNo);
        this.combinedMenuFlowPages$ = this.controllers.menuFlows.getCombinedMenuFlowPages$(this.menuFlowId, this.locationNo);
        this.showSpecialInstructions$ = this.controllers.wizzard.showSpecialInstructions$(this.type);
        this.showQuantityWizard$ = this.controllers.wizzard.showQuantityWizard$(this.type);
        this.hasSpecialInstructions$ = this.controllers.wizzard.hasSpecialInstructions$(this.type);
        this.isEditing$ = this.controllers.wizzard.isEditing$(!!this.menuFlowId);

        if (this.menuFlowId) {
            this.wizzardMenuFlow$ = this.controllers.wizzard.wizzardMenuFlow$();
        }
    }

    public trackBy(item: State.IMenuFlows, index: number): number {
        return item?.MenuFlowId || index;
    }
}
